/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-09-27 03:31:32
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-12 00:12:44
 */

import { Injectable } from "@angular/core";
import { Celeb, celebGenLocals } from "../models/celeb.model";
import { AuthService } from "./auth.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { CelebService } from "./celeb.service";

import { Storage } from "@ionic/storage";

@Injectable()
export class ManagerService {
  isCelebMode = false;
  isUserModeInCelebMode = false;

  celebSelected: Celeb;
  members: Celeb[];

  private _switchAccount: BehaviorSubject<any> = new BehaviorSubject(null);
  private _setCeleb: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private storage: Storage,
    private celebService: CelebService,
    private authService: AuthService
  ) {}

  init() {
    this.isCelebMode = this.authService.isManager || this.authService.isCeleb;
  }

  switchAccount(data) {
    if (data) {
      if (data.type === "CELEB") {
        this.changeToCeleb(data.id);
      } else if (data.type === "USER") {
        this.changeToUser();
      }
    }
  }

  get switchAccount$() {
    return this._switchAccount.asObservable();
  }

  get setCeleb$() {
    return this._setCeleb.asObservable();
  }

  updateMembers() {
    if (
      this.authService.isManager &&
      this.authService.user &&
      this.authService.user.celeb
    ) {
      this.celebService
        .getCeleb(this.authService.user.celeb._id)
        .subscribe(res => {
          const group = res["payload"];
          this.members = group.members;
        });
    }

    if (this.celebSelected) {
      this.celebService.getCeleb(this.celebSelected._id).subscribe(res => {
        this.celebSelected = res["payload"];
      });
    }
  }

  clear() {
    this._switchAccount.next(null);
    this._setCeleb.next(null);
    this.members = null;
  }

  changeToCeleb(celebId) {
    this.setCurrentCeleb(celebId).then(() => {
      this.isCelebMode = true;
      this.isUserModeInCelebMode = false;
      this._switchAccount.next({ type: "CELEB", id: celebId });
    });
  }

  changeToUser() {
    this.isCelebMode = false;
    this.isUserModeInCelebMode = true;
    this._switchAccount.next({
      type: "USER"
    });
  }

  getCurrentCeleb() {
    return this.storage.get("current-celeb");
  }

  setCurrentCeleb(id) {
    this.storage.set("current-celeb", id);

    return new Promise((resolve, reject) => {
      this.celebService.getCeleb(id).subscribe(res => {
        this.celebSelected = res["payload"];
        celebGenLocals(this.celebSelected, this.authService.userId);
        this._setCeleb.next(this.celebSelected);
        resolve();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/manager.service.ts